<template>
  <div class="order">
    <div class="header">
      <div class="header-left">
        <span class="title">订单数据</span>
        <span class="time">数据更新时间:{{now_data}}</span>
      </div>
      <div class="more" @click="toPage('全部')">
        我的订单
        <Icon type="ios-arrow-forward"/>
      </div>
    </div>
    <!-- <div class="total"> -->
    <Row class="total">
      <orderItem title="待雇佣" id='2' v-if="is_show" :num.sync="no_hore" ></orderItem>
      <orderItem title="待支付" id='3' v-if="is_show" :num.sync="no_pay" ></orderItem>
      <orderItem title="服务中" id='5'  v-if="is_show" :num.sync="no_service" ></orderItem>
      <orderItem title="待评价" id='7' v-if="is_show" :num.sync="no_evalu" ></orderItem>
      <orderItem title="待验收" id='6' v-if="is_show" :num.sync="check" ></orderItem>
      <orderItem title="已完成" id='8' v-if="is_show" :num.sync="finshed" ></orderItem>
    </Row>
    <!-- </div> -->
  </div>
</template>

<script>
import orderItem from './order-item'
import store from '@/store/index'
import { getUserInfo } from '@/api/user'
export default {
  name: 'order',
  components: {
    orderItem
  },
  data () {
    return {
      now_data: '',
      no_pay: 0,
      no_hore: 0,
      no_service: 0,
      no_evalu: 0,
      finshed: 0,
      check: 0,
      balance: 0,
      head_img: '',
      nickname: '',
      is_show: false
    }
  },
  created () {
    this.now_data = this.getNowFormatDate()
    let vm = this
    this.$store.dispatch('getUserInfo').then(res => {
      vm.no_pay = res.no_pay
      vm.no_hore = res.no_hore
      vm.no_service = res.no_service
      vm.no_evalu = res.no_evalu
      vm.finshed = res.finshed
      vm.balance = res.balance
      vm.head_img = res.head_img
      vm.nickname = res.nickname
      vm.check = res.check
      this.is_show = true
    })
  },
  methods: {
    toPage () {
      this.$router.push({ name: 'order_list', query: { fromWorkbench: '1' } })
    },
    getNowFormatDate () {
      var date = new Date()
      var seperator1 = '-'
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate
      return currentdate
    }
  }
}
</script>

<style scoped lang="less">
.order {
  width: 100%;
  margin-top: 10px;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .header-left {
      display: flex;
      align-items: center;

      .title {
        color: rgb(51, 51, 51);
        font-size: 18px;
        letter-spacing: 0px;
        margin-right: 12px;
      }

      .time {
        color: rgb(153, 153, 153);
        font-size: 12px;
      }
    }

    .more{
      display: flex;
      align-items: center;
      color: rgb(102, 102, 102);
      font-size: 14px;
      cursor: pointer;
    }
  }
  .total{
    margin-top: 10px;
  }
}
</style>
